import { render, staticRenderFns } from "./ProductsListItemProduct.vue?vue&type=template&id=6ef0aec6&"
import script from "./ProductsListItemProduct.vue?vue&type=script&lang=js&"
export * from "./ProductsListItemProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports